import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Register from "./Components/Register";
import ViewData from "./Components/ViewData";

function App() {
  return (
    <Router>
      <div> 
        {/* ✅ Navigation Bar */}
        <nav style={navStyle}>
  {/* Left Side: Logo + Company Name */}
  <div style={{ display: "flex", alignItems: "center", flex: "1 1 auto" }}>
        <img
  src="/TT_logo2.png"
  alt="Logo"
  style={logoStyle}
/>
            {/* This was causing the error because companyNameStyle wasn't defined below */}
            <h2 style={companyNameStyle}>Tapasya Technovation</h2>
   </div>

  {/* Right Side: Website Link */}
 <div style={{ flex: 1, textAlign: "right" }}>
    <a
      href="https://tapasyatech.in"
      target="_blank"
      rel="noopener noreferrer"
      style={linkStyle}
      onMouseOver={(e) => (e.target.style.color = "#007bff")}
  onMouseOut={(e) => (e.target.style.color = "#000")}
    >
     Know Us Better →
    </a>
  </div>
</nav>
        {/* ✅ Routes */}
        <Routes>
          <Route path="/" element={<Register />} />
         <Route path="/viewdata" element={<ViewData />} />
        </Routes>
      </div>
    </Router>
  );
}

// ✅ Inline styles (you can move to CSS)
// const navStyle = {
//   display: "flex",
//   justifyContent: "space-between",
//   padding: "15px 20px",
//   background: "#ffffff",
//   boxSizing: "border-box",
//   color: "#000000",
//   alignItems: "center"
  
// };

// const linkStyle = {
//   marginLeft: "15px",
//   color: "#000000",
//   textDecoration: "underline",   // ✅ underline added
//   fontWeight: "bold",
//   fontSize: "18px",              // ✅ bigger text
//   cursor: "pointer",
//   transition: "0.3s"
// };

// Update navStyle in App.js
const navStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 40px",
  background: "#ffffff",
  color: "#0F3343",
  width: "100%",
  boxSizing: "border-box",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  position: "sticky",
  top: 0,
  zIndex: 1000,
  height: "95px", // fixed navbar height
};

const linkStyle = {
  color: "#007bff",
  textDecoration: "none",
  fontWeight: "bold",
  fontSize: "16px",
  whiteSpace: "nowrap",
  paddingBottom: "5px",      /* Gives a tiny gap from the very bottom edge */
  display: "block"
};

const companyNameStyle = {
  marginLeft: "15px",
  fontSize: "clamp(16px, 4vw, 22px)", 
  whiteSpace: "normal",               
  lineHeight: "1.2",
  fontWeight: "bold",
  color: "#000"
};
const logoStyle = {
  height: "130px",
  width: "auto",
  objectFit: "contain",
  transform: "scale(1.5)",
  transformOrigin: "left center",
  marginRight: "70px",
};

const contactStyle = {
  position: "fixed",
  bottom: "10px",
  right: "15px",
  background: "#0F3343",
  color: "#fff",
  padding: "8px 12px",
  borderRadius: "5px",
  fontSize: "14px"
};



export default App;